import { Heart, Zap, Globe } from "lucide-react";
import { GlobalConnectLimits } from "@/hooks/useGlobalConnect";

interface GlobalConnectLimitsBarProps {
  limits: GlobalConnectLimits;
}

export const GlobalConnectLimitsBar = ({
  limits,
}: GlobalConnectLimitsBarProps) => {
  const countriesUsed = limits.countries_visited?.length || 0;
  const countriesRemaining = Math.max(0, 3 - countriesUsed);
  
  return (
    <div className="flex items-center gap-4 mt-2 text-xs">
      <div className="flex items-center gap-1">
        <Heart className="w-3.5 h-3.5 text-pink-500" />
        <span className="text-muted-foreground">
          <span className="text-foreground font-medium">{limits.likes_remaining ?? 0}</span> likes left
        </span>
      </div>
      <div className="flex items-center gap-1">
        <Zap className="w-3.5 h-3.5 text-amber-500" />
        <span className="text-muted-foreground">
          <span className="text-foreground font-medium">{limits.pops_remaining ?? 0}</span> pops left
        </span>
      </div>
      <div className="flex items-center gap-1">
        <Globe className="w-3.5 h-3.5 text-primary" />
        <span className="text-muted-foreground">
          <span className="text-foreground font-medium">{countriesRemaining}</span> countries left
        </span>
      </div>
    </div>
  );
};
